@if (bannerEnabled && bannerMessage) {
  <div class="maintenance-banner">
    <i class="pi pi-exclamation-triangle mr-2"></i>
    {{ bannerMessage }}
  </div>
}
